var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    menu: true,
    mr30: _vm.isDesktopMenuMargin(_vm.$route),
    'is-modal': _vm.modal
  }, _obj[_vm.$mq] = true, _obj )},[_c('div',{staticClass:"menu__content"},_vm._l((_vm.routes),function(route){return _c('div',{key:route.id,class:{
        menu__item: true,
        'is-active': _vm.$route.name === route.name,
        disabled: route.disabled,
      }},[_c('div',{staticClass:"link-route",on:{"click":function($event){return _vm.itemClick(route)},"mouseenter":function($event){return _vm.mouseHover(route.name, 'add')},"mouseleave":function($event){return _vm.mouseHover(route.name)}}},[_c('div',{staticClass:"link-route__img"},[_c('img',{attrs:{"alt":route.name,"src":_vm.getAsset(
                _vm.mobile && route.mobileIcon ? route.mobileIcon : route.icon,
                {
                  path: 'menu',
                  modifier:
                    _vm.$route.name == route.name ||
                    (_vm.hovered === route.name && !route.mobileIcon)
                      ? 'active'
                      : '',
                }
              )}})]),_c('div',{staticClass:"link-route__title"},[_vm._v(" "+_vm._s(_vm.applyLanguage(route.id))+" ")]),_c('div',{staticClass:"link-route__subtitle"},[_vm._v("Coming Soon")])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }